import '../App.css';
import { useEffect, useMemo, useState } from 'react';
import throttle from 'lodash/throttle';

import PropTypes from 'prop-types';
import Paper from '@mui/material/Paper';
import Slider from '@mui/material/Slider';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';

import FormControlLabel from '@mui/material/FormControlLabel';
import Checkbox from '@mui/material/Checkbox';

import { styled } from '@mui/material/styles';
import { DataGrid } from '@mui/x-data-grid';
import Link from '@mui/material/Link';

import FilterBar from '../FilterBar.js'

import { binary_search } from '../util.ts'

const Item = styled(Paper)(({ theme }) => ({
  ...theme.typography.body2,
  padding: theme.spacing(1),
  textAlign: 'center',
  color: theme.palette.text.secondary,
}));

// TODO: when make some filter of columns, uncomment the rows below
const awardsList = [
  {award_id: 'air', name: 'Airforce General'},
  {award_id: 'vet', name: 'Decorated Veteran'},
  {award_id: 'shell', name: 'Turtle Shell'},
  {award_id: 'ouch', name: 'Big Purple Heart'},
  {award_id: 'pwn', name: 'Complete Annihilation'},
  {award_id: 'reclaim', name: 'Spoils of War'},
  {award_id: 'kam', name: 'Kamikaze Award'},
  // {award_id: 'friend', name: 'Friendly Fire Award'},
  {award_id: 'terra', name: 'Legendary Landscaper'},
  {award_id: 'emp', name: 'EMP Wizard'},
  {award_id: 'fire', name: 'Master Grill-Chef'},
  {award_id: 'share', name: 'Share Bear'},
  {award_id: 'mex', name: 'Mineral Prospector'},
  {award_id: 'mexkill', name: 'Loot & Pillage'},
  {award_id: 'slow', name: 'Traffic Cop'},
  {award_id: 'comm', name: 'Master and Commander'},
  {award_id: 'navy', name: 'Fleet Admiral'},
  {award_id: 'cap', name: 'Master of Puppets'},
  {award_id: 'disarm', name: 'Peacemaker'},
  {award_id: 'nux', name: 'Apocalyptic Achievement Award'},
  {award_id: 'head', name: 'Head Hunter'},
  // {award_id: 'silver', name: 'Silver Cup'},
  {award_id: 'rezz', name: 'Vile Necromancer'},
  // {award_id: 'sweeper', name: 'Land Sweeper'},
  // {award_id: 'bronze', name: 'Bronze Cup'},
  // {award_id: 'dragon', name: 'Dragon Slayer'},
  // {award_id: 'heart', name: 'Queen Heart Breaker'},
  // {award_id: 'gold', name: 'Gold Cup'},
]

var columnsAwards: GridColDef[] = [
  { field: 'id', headerName: '', width: 50,
    renderCell: (params) => {
      return params.api.getRowIndex(params.row.id) + 1;
    },
  },
  { field: 'player', headerName: 'Player', width: 200,
    renderCell: (params) => {
      return (
        <Link target="_blank" href={`http://zero-k.info/Users/Detail/${params.value.id}`}>{params.value.nickname}</Link>
        )
    },
  }].concat((() => {
    return awardsList.map((e) => (
      { field: e.award_id, headerName: e.name, width: 150, type: "number", }
    ));
  })());

function PlayerAward(props) {
  const [filterBar, setFilterBar] = useState(null);

  const [rowsPlayersAwards, setRowsPlayersAwards] = useState([]);

  const [minimumGamesDisplay, setMinimumGamesDisplay] = useState(0);
  const [maximumGames, setMaximumGames] = useState(1000);
  const [countGames, setCountGames] = useState(1000);

  const [normalization, setNormalization] = useState(false);

  useEffect(() => {
    var i;

    if(filterBar!==null) {
      var processingStartTimeFirst = Date.now();

      props.jsonBattles.min = binary_search(props.jsonBattles.started_sec, (filterBar.startDate/1000), false, true);
      props.jsonBattles.max = binary_search(props.jsonBattles.started_sec, (filterBar.endDate/1000), true, false);

      // Dictionary with keys player id-s and values a dictionary with awards count.
      var playerAward = {};

      // Dictionary with keys player id-s and value the number of games played
      var playerGames = {};

      var gamesIds = filterBar.gamesChecked;

      var count_battles = 0;

      for(i=props.jsonBattles.min; i<=props.jsonBattles.max; i++) {
        var gameTypeOk = false;
        var j;
        for(j=0;j<filterBar.gameTypesChecked.length;j++) {
          if(filterBar.gameTypesChecked[j] && filterBar.gameTypesAvailable[j].func_filter(props.jsonBattles,i)) {
            gameTypeOk = true;
            break;
          }
        }
        if(!gameTypeOk) {
          continue;
        }

        if(!gamesIds.includes(props.jsonBattles.game_id[i])) {
          continue;
        };

        const map_idx = binary_search(props.jsonMaps.map_id, props.jsonBattles.map_id[i]);

        if(!filterBar.mapTypeAvailableChecked.map((elem, j) =>
            (!elem || filterBar.mapTypeAvailable[j]['value'] === props.jsonMaps[filterBar.mapTypeAvailable[j]['column']][map_idx])).every((x)=>x)) {
              continue;
        }
        var area = props.jsonMaps.size_x[map_idx]*props.jsonMaps.size_y[map_idx];
        if(area<filterBar.mapSize[0] || filterBar.mapSize[1]<area) {
          continue;
        }

        const battle_player_idx_first = binary_search(props.jsonBattlePlayer.battle_id, props.jsonBattles.battle_id[i], true, false, true);

        var playersFound = false;
        var battle_player_idx = battle_player_idx_first;
        while(props.jsonBattlePlayer.battle_id[battle_player_idx] === props.jsonBattles.battle_id[i]) {
          const battle_player_id = props.jsonBattlePlayer.player_id[battle_player_idx];
          if (battle_player_id === filterBar.playerId) {
            playersFound = true;
          }

          if(!(battle_player_id in playerGames)) {
            playerGames[battle_player_id] = 1;
          } else {
            playerGames[battle_player_id] += 1;
          }

        	battle_player_idx++;
      	}

        if (filterBar.playerId && !playersFound) {
          continue;
        }
        count_battles++;

        // Record award associations
        var award_idx = binary_search(props.jsonAwards.battle_id, props.jsonBattles.battle_id[i], true, false, true);
        while(props.jsonAwards.battle_id[award_idx] === props.jsonBattles.battle_id[i]) {
          const crtPlayerId = props.jsonAwards.player_id[award_idx]
          if(!(crtPlayerId in playerAward)) {
            playerAward[crtPlayerId] = {};
          }

          const crtAwardId = props.jsonAwards.award_id[award_idx];
          if(!(crtAwardId in playerAward[crtPlayerId])) {
            playerAward[crtPlayerId][crtAwardId] = 1;
          } else {
            playerAward[crtPlayerId][crtAwardId] += 1;
          }

        	award_idx++;
      	}
      };

      setMaximumGames(Math.max(...Object.keys(playerGames).map((k)=>playerGames[k])));
      setCountGames(count_battles);

      // Compute for each award the order of the player

      /////////////////////////////////
      // Player asscoations team mates
      const awards_table = Object.keys(playerAward).filter((p) => {
          return playerGames[p]>=minimumGamesDisplay;
        }).map((p) => {
          const v = playerAward[p];
          const idx = binary_search(props.jsonPlayers.player_id, p);
          if(normalization) {
            var keys = Object.keys(v);
            for(var k in keys) {
              v[keys[k]] /= playerGames[p];
            }
          }
          // TODO: remove players with no awards?
          return {
            p: p,
            a: v,
          };
        });

      const awards_columns = awardsList.map((a) => {
        var column = [];
        awards_table.map((e) => {
          if(a.award_id in e.a) {
            column.push(e.a[a.award_id]);
          }
        });
        return column;
      });

      if (filterBar.playerId) {
          // For the selected player we find the awards
          const awards_player = awards_table.find((x)=>x.p==filterBar.playerId);
          Object.keys(awards_player.a).map((a) => {
            const idx_award = awardsList.findIndex((x)=>x.award_id===a);

            const position = awards_columns[idx_award].length - awards_columns[idx_award].sort().findIndex((x)=>x===awards_player.a[a]);
          })
      }

      console.log("INFO: PlayerAwardName complete time "+(Date.now()-processingStartTimeFirst));
      return;
    }
  }, [filterBar, minimumGamesDisplay, normalization, props.jsonAwards, props.jsonBattlePlayer,
      props.jsonBattles, props.jsonGames, props.jsonMaps, props.jsonPlayers])

  useEffect(() => {
    setMinimumGamesDisplay(maximumGames*0.5);
  }, [maximumGames]);

  const gamesDisplaySet = useMemo(
    () =>
      throttle((value) => setMinimumGamesDisplay(value), 500),
    [],
  );

  // TODO: maybe these two should be moved as a property of filter bar
  var player_nickname = "";
  if(filterBar!==null) {
    const player_idx = props.jsonPlayers.player_id.findIndex((x)=>x===filterBar.playerId);
    player_nickname = props.jsonPlayers.nickname[player_idx];
  }

  return (
    <div>
      <Stack spacing={2}>
        <Item>
          <FilterBar
            jsonBattles={props.jsonBattles}
            jsonBattlePlayer={props.jsonBattlePlayer}
            jsonGames={props.jsonGames}
            jsonMaps={props.jsonMaps}
            jsonPlayers={props.jsonPlayers}
            updateCallback={x=>setFilterBar(x)}
            hideAccountAge={true}
            hideTimeGranularity={true}
          />
        </Item>
        <Item>
          <Stack direction="row" spacing={1}>
            <Item style={{ width: "100%" }}>

              <Stack direction="row" spacing={1}>
                <Item style={{ width: "50%" }}>
                  <Typography>
                    Number of awards per player from {countGames} battles.
                  </Typography>
                  {player_nickname && <Typography>  Showing only battles in which player "{player_nickname}" played.</Typography>}
                  <Typography>
                    Note: hover over table heading to see options for sorting and column selection.
                  </Typography>
                </Item>
                <Item style={{ width: "50%" }}>
                  <Typography> Show only players with at least an amount of games played</Typography>
                  <Slider
                    onChange={(_, newValue) => { setMinimumGamesDisplay(newValue); gamesDisplaySet(newValue); } }
                    value={minimumGamesDisplay}
                    track={false}
                    step={1}
                    min={1}
                    max={maximumGames}
                    valueLabelDisplay="auto"
                  />
                </Item>
                <Item style={{ width: "50%" }}>
                  <Typography>Divide number of awards by number of games that player played</Typography>
                  <FormControlLabel
                    control={<Checkbox checked={normalization} onChange={(e)=>setNormalization(!normalization)}/>}
                    label="Normalize"
                  />
                </Item>
              </Stack>

              <div style={{ height: 600, width: '100%' }}>
               <DataGrid rows={rowsPlayersAwards} columns={columnsAwards} />
             </div>
            </Item>
          </Stack>
        </Item>
      </Stack>
    </div>
  );
}

PlayerAward.propTypes = {
  jsonAwards: PropTypes.object,
  jsonBattles: PropTypes.object,
  jsonBattlePlayer: PropTypes.object,
  jsonGames: PropTypes.object,
  jsonMaps: PropTypes.object,
  jsonPlayers: PropTypes.object,
};

export default PlayerAward;
